<template>
  <div>
    <div class="chat-site-header">
      <span class="u-fontsize-lg u-mb-0">
        {{ pgettext('Chat timeline heading', 'Chat timeline from') }}
      </span>
      <div class="chat-site-actions">
        <a
          class="link--search u-fontsize-lg u-weight-bold"
          :href="`${messageSearchUrl}?filters=site_name:${siteName}`"
        >
          {{ siteName }}
        </a>
        <note-buttons
          :noteId="siteId"
          :noteName="siteName"
          :noteItem="'chat site'"
          :noteSiteId="siteId"
          :noteSiteName="siteName"
          :hasNotes="Boolean(parseInt(hasChatSiteNotes))"
          :indexType="'chat'"
          :watchlistMessage="{
            'url':siteUrl,
            'site_watchlist': inWatchlist,
            '_source': {
              'site_id': siteId,
              'site_name': siteName,
            }
          }"
          :siteLink="getSiteLink(siteName)"
        />
        <button
          class="loi-form-open-btn"
          :title="loiToolTip"
          @click.prevent="loiFormOpen = true"
        />
      </div>
    </div>

    <div
      v-if="loiFormOpen"
      class="topic-link-popup-form"
    >
      <location-of-interest-form
        :existingUrls="existingUrls"
        :formAction="loiFormAction"
        :fullTagList="existingTags"
        :initialData="chatData"
        @formCancel="loiFormOpen = false"
        @formSubmit="refreshPage"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import LocationOfInterestForm from '../forms/LocationOfInterestForm'
import NoteButtons from '../notes/NoteButtons'

export default {
  name: 'ChatContextSiteHeader',
  components: {
    LocationOfInterestForm,
    NoteButtons,
  },
  props: {
    inWatchlist: {
      type: Boolean,
      required: true
    },
    messageSearchUrl: {
      type: String,
      required: true
    },
    siteName: {
      type: String,
      required: true
    },
    siteId: {
      type: String,
      required: true
    },
    siteUrl: {
      type: String,
      default: ''
    },
    hasChatSiteNotes: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      note: '',
      noteType: '',
      noteCategory: '',
      all_chat_messages: [],
      chatData: {},
      existingTags: [],
      existingUrls: [],
      loiFormAction: 'create',
      loiFormOpen: false,
      loiToolTip: '',
      limit: 10,
      loading: false,
      siteWatchlist: '',
      timeframe: '1209600'
    }
  },
  mounted() {
    // get site info for creating or editing a location of interest
    axios.get(`/en/topic/chat_messages/${this.siteId}`).then(response => {
      if (response.status === 200) {
        this.existingUrls = response.data.existing_urls
        this.existingTags = response.data.existing_tags
        this.chatData = response.data.topic_link
        if (this.chatData == null) {
          this.loiFormAction = 'create'
          this.loiToolTip = 'Create a new location of interest for chat.'
          this.chatData = {
            'url': this.siteUrl,
            'title': this.siteName
          }
        } else {
          this.loiFormAction = 'update'
          this.loiToolTip = 'Update the location of interest for chat.'
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  },
  methods: {
    getSiteLink(siteName) {
      return new URL('/en/message-search/chat-sites/' + siteName + '/', document.baseURI).href
    },
    refreshPage() {
      // call needs to be here because when used directly in the vue component it
      // has no context for 'window'.
      window.location.reload()
    }
  },
}
</script>

<style scoped>

.chat-site-header {
  display: flex;
  flex-flow: column;
  .chat-site-actions {
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    align-items: center;
    .loi-form-open-btn {
      width: 32px;
      height: 32px;
      background-image: url('/static/images/icons/icon-globe.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
}

</style>
